// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EditorContextMenu {\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\n.EditorTemplateContent {\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(224, 224, 244, 0.5);\n}\n\n.TableElement {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: \"...\";\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
